// Configuration API
const API_BASE_URL = import.meta.env.VITE_REACT_APP_API_EP_URI;

export interface MoodleSyncImport {
  label: string;
  last_import_at: string | null;
}

export interface MoodleSyncCycle {
  started_at: string;
  finished_at: string;
  outcome: 'ok' | 'no_token' | 'session_expired' | 'error';
}

export interface MoodleSyncStatus {
  paused: boolean;
  running: boolean;
  interval_min: number;
  next_cycle_at: string | null;
  last_cycle: MoodleSyncCycle | null;
  session: 'ok' | 'expired' | 'unknown';
  api: 'ok' | 'token_refused' | 'unknown';
  imports: Record<string, MoodleSyncImport>;
  alerts: Record<string, string>;
  now: string;
}

export type MoodleSyncAction = 'pause' | 'resume' | 'run-now';

async function callApi(path: string, method: 'GET' | 'POST', accessToken: string): Promise<any> {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${accessToken}`
    },
  });

  const json = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(json.message || `HTTP error! status: ${response.status}`);
  }

  return json;
}

class MoodleSyncService {

  async getStatus(accessToken: string): Promise<MoodleSyncStatus> {
    const json = await callApi('/admin/moodle-sync/status', 'GET', accessToken);
    return json.data;
  }

  async act(action: MoodleSyncAction, accessToken: string): Promise<MoodleSyncStatus> {
    const json = await callApi(`/admin/moodle-sync/${action}`, 'POST', accessToken);
    return json.data;
  }
}

export const moodleSyncService = new MoodleSyncService();
